export const getBrands = (state) => state.publicData.brands;
export const getCountries = (state) => state.publicData.countries;
